import { clientEnvModule } from "@/modules/client-env";

/**
 * Gets the current window's hostname for web environments.
 * Returns undefined for desktop environments where hostname is not applicable.
 */
export const getWindowLocationHostname = (): string | undefined => {
  const isDesktop = clientEnvModule.isDesktop();
  if (isDesktop) return undefined;

  // eslint-disable-next-line no-restricted-properties
  return window.location.hostname;
};
